import { render, staticRenderFns } from "./PatientsReport.vue?vue&type=template&id=2268deb6&"
import script from "./PatientsReport.vue?vue&type=script&lang=js&"
export * from "./PatientsReport.vue?vue&type=script&lang=js&"
import style0 from "./PatientsReport.vue?vue&type=style&index=0&id=2268deb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports